export const GET_STACK_PROBLEMS_REQUEST = 'LIBRARY.GET_STACK_PROBLEMS_REQUEST';
export const GET_STACK_PROBLEMS_SUCCESS = 'LIBRARY.GET_STACK_PROBLEMS_SUCCESS';
export const GET_STACK_PROBLEMS_ERROR = 'LIBRARY.GET_STACK_PROBLEMS_ERROR';

export const CLOSE_SUPER_MENU = 'LIBRARY.CLOSE_SUPER_MENU';

export const GET_ALL_ATTRIBUTES_REQUEST = 'LIBRARY.GET_ALL_ATTRIBUTES_REQUEST';
export const GET_ALL_ATTRIBUTES_SUCCESS = 'LIBRARY.GET_ALL_ATTRIBUTES_SUCCESS';
export const GET_AVAILABLE_ATTRIBUTES_REQUEST = 'LIBRARY.GET_AVAILABLE_ATTRIBUTES_REQUEST';
export const GET_AVAILABLE_ATTRIBUTES_SUCCESS = 'LIBRARY.GET_AVAILABLE_ATTRIBUTES_SUCCESS';

export const APPLY_FILTER_FROM_URL = 'LIBRARY.APPLY_FILTER_FROM_URL';
export const CHANGE_FILTER_VALUE = 'LIBRARY.CHANGE_FILTER_VALUE';
export const SET_FILTER_VALUE = 'LIBRARY.SET_FILTER_VALUE';
export const SET_FILTERS = 'LIBRARY.SET_FILTERS';
export const CLEAR_FILTERS = 'LIBRARY.CLEAR_FILTERS';

export const SELECT_STACK = 'LIBRARY.SELECT_STACK';
export const SELECT_DEEP_LINK_STACK = 'LIBRARY.SELECT_DEEP_LINK_STACK';
export const SET_DEEP_LINK_STACK = 'LIBRARY.SET_DEEP_LINK_STACK';
export const ADD_PROBLEM_TO_LESSON = 'LIBRARY.ADD_PROBLEM_TO_LESSON';

export const GET_THEME_DETAILS_REQUEST = 'LIBRARY.GET_THEME_DETAILS_REQUEST';
export const GET_THEME_DETAILS_SUCCESS = 'LIBRARY.GET_THEME_DETAILS_SUCCESS';
export const GET_THEME_DETAILS_ERROR = 'LIBRARY.GET_THEME_DETAILS_ERROR';

export const LOAD_STACKS_REQUEST = 'LIBRARY.LOAD_STACKS_REQUEST';
export const LOAD_STACKS_SUCCESS = 'LIBRARY.LOAD_STACKS_SUCCESS';
export const LOAD_STACKS_ERROR = 'LIBRARY.LOAD_STACKS_ERROR';

export const CLEAR_PREP_LESSONS_DETAILS = 'LIBRARY.CLEAR_PREP_LESSONS_DETAILS';

export const CLEAR_STACKS = 'LIBRARY.CLEAR_STACKS';

export const LESSON_MODAL_CLOSE = 'LIBRARY.LESSON_MODAL_CLOSE';
export const SAVE_LESSON = 'LIBRARY.SAVE_LESSON';

export const ADD_NEW_SUBJECT = 'LIBRARY.ADD_NEW_SUBJECT';
export const ADD_NEW_SUBJECT_CANCEL = 'LIBRARY.ADD_NEW_SUBJECT_CANCEL';
export const ADD_NEW_SUBJECT_SUCCESS = 'LIBRARY.ADD_NEW_SUBJECT_SUCCESS';

export const GET_COURSES_PREVIEW_REQUEST = 'LIBRARY.GET_COURSES_PREVIEW_REQUEST';
export const GET_COURSES_PREVIEW_SUCCESS = 'LIBRARY.GET_COURSES_PREVIEW_SUCCESS';
export const GET_COURSES_PREVIEW_ERROR = 'LIBRARY.GET_COURSES_PREVIEW_ERROR';
